// Tolerance category mapping composable
export interface ToleranceCategoryMapping {
  ToleranceCategoryId: number
  ParameterTranslationKey: string
}

export function useToleranceCategoryMapping() {
  // Tolerance category mapping data
  const toleranceCategoryMapping: ToleranceCategoryMapping[] = [
    {
      'ToleranceCategoryId': 3,
      'ParameterTranslationKey': 'd1'
    },
    {
      'ToleranceCategoryId': 4,
      'ParameterTranslationKey': 'd2'
    },
    {
      'ToleranceCategoryId': 1,
      'ParameterTranslationKey': 'd4'
    },
    {
      'ToleranceCategoryId': 2,
      'ParameterTranslationKey': 'd9'
    },
    {
      'ToleranceCategoryId': 2,
      'ParameterTranslationKey': 'd3Groove'
    },
    {
      'ToleranceCategoryId': 12,
      'ParameterTranslationKey': 'b1'
    },
    {
      'ToleranceCategoryId': 5,
      'ParameterTranslationKey': 'r1'
    },
    {
      'ToleranceCategoryId': 11,
      'ParameterTranslationKey': 'r2'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'OutsideDiameter'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 't'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'StretchingRatio'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'CompressionRatio'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'CompressionRatioExcentric'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'FillingRatio'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'InstalledWidthAx'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'InstalledWidthRad'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'InstalledOutsideDiameter'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'RepulsionForce'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'ContactWidth'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'Weight'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'SurfaceArea'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'RingVolume'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'BauraumVolume'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'RingArea'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'BauraumArea'
    },
    {
      'ToleranceCategoryId': 7,
      'ParameterTranslationKey': 'ChamferAngle'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'ChamferLengthZ'
    },
    {
      'ToleranceCategoryId': 4,
      'ParameterTranslationKey': 'd3'
    },
    {
      'ToleranceCategoryId': 7,
      'ParameterTranslationKey': 'g'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'CenterGravity'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'b2'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'b3'
    },
    {
      'ToleranceCategoryId': 2,
      'ParameterTranslationKey': 'd5'
    },
    {
      'ToleranceCategoryId': 1,
      'ParameterTranslationKey': 'd10'
    },
    {
      'ToleranceCategoryId': 1,
      'ParameterTranslationKey': 'd6'
    },
    {
      'ToleranceCategoryId': 1,
      'ParameterTranslationKey': 'd7'
    },
    {
      'ToleranceCategoryId': 2,
      'ParameterTranslationKey': 'd8'
    },
    {
      'ToleranceCategoryId': 9,
      'ParameterTranslationKey': 'b4'
    },
    {
      'ToleranceCategoryId': 10,
      'ParameterTranslationKey': 'h'
    },
    {
      'ToleranceCategoryId': 5,
      'ParameterTranslationKey': 'f'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'HoldingRatio'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'InstalledInnerDiameter'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'RRingVolume'
    },
    {
      'ToleranceCategoryId': 7,
      'ParameterTranslationKey': 'maxClearanceExcentric'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'SqueezeInterference'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'Stretching'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'Holding'
    },
    {
      'ToleranceCategoryId': 14,
      'ParameterTranslationKey': 'cr'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'HsAx'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'HsRad'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'd2VSd3'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'InsideDiameter'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'RadialWidth'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'AxialWidth'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'GrooveDepth'
    },
    {
      'ToleranceCategoryId': 7,
      'ParameterTranslationKey': 'mountingGuidanceX'
    },
    {
      'ToleranceCategoryId': 7,
      'ParameterTranslationKey': 'mountingGuidanceY'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'crAx'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'crRad'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'alphaAx'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'alphaCrAx'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'alphaRad'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'alphaCrRad'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'manRingVolume'
    },
    {
      'ToleranceCategoryId': 6,
      'ParameterTranslationKey': 'manBauraumVolume'
    },
    {
      'ToleranceCategoryId': 7,
      'ParameterTranslationKey': 'manMaxClearanceExcentric'
    }
  ]

  // Create a mapping function for easier lookup
  const createParameterCategoryMap = (): Record<string, number> => {
    const mapping: Record<string, number> = {}
    toleranceCategoryMapping.forEach((item) => {
      mapping[item.ParameterTranslationKey] = item.ToleranceCategoryId
    })
    return mapping
  }

  // Get tolerance category ID for a parameter
  const getToleranceCategoryId = (parameterKey: string): number | undefined => {
    const item = toleranceCategoryMapping.find(
      mapping => mapping.ParameterTranslationKey === parameterKey
    )
    return item?.ToleranceCategoryId
  }

  // Get all mappings
  const getAllMappings = (): ToleranceCategoryMapping[] => {
    return [...toleranceCategoryMapping]
  }

  // Get mappings by category ID
  const getMappingsByCategoryId = (categoryId: number): ToleranceCategoryMapping[] => {
    return toleranceCategoryMapping.filter(
      mapping => mapping.ToleranceCategoryId === categoryId
    )
  }

  return {
    toleranceCategoryMapping: readonly(toleranceCategoryMapping),
    createParameterCategoryMap,
    getToleranceCategoryId,
    getAllMappings,
    getMappingsByCategoryId
  }
}
